import React, { useState } from 'react';
import { Link } from 'react-router-dom';
/* eslint max-len: ["error", { "code": 250 }] */

const LandingPage = () => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  return (
    <div className="landing-page">
      <video
        id="youtube-player"
        title="video-player"
        autoPlay
        playsInline
        controls={false}
        muted
        loop
        src="https://metiormedia.s3.us-east-1.amazonaws.com/assets/bg-video.mp4"
        controlsList="nodownload"
        width="100%"
        height="100%"
        style={{ display: isVideoLoaded ? 'block' : 'none', position: 'absolute' }}
        onLoadedData={() => setIsVideoLoaded(true)}
      />

      <div className="container">
        <h2>METIOR</h2>

        <div className="wrapper">
          <button className="transparent-button" type="button">Tienda</button>
          <Link to="/metior"><button className="transparent-button" type="button">Metior</button></Link>
        </div>

        <div className="footer">
          <a href="https://mail.google.com/mail/u/0/?source=mailto&to=sebastian.almeida@sagaon.tech&fs=1&tf=cm&su=Informacion%20adicional%20sobre%20la%20calculadora&body=Me%20interesa%20convertirme%20en%20usuario%20premium">
            <img draggable={false} width="20px" height="20px" className="icon" alt="e.i" src="https://imgur.com/gnYgfjB.png" />
          </a>
          <a href="https://api.whatsapp.com/send/?phone=%2B524421472246&text=Hola.+Estoy+interesado+en+utilizar+la+calculadora+METIOR&app_absent=0">
            <img draggable={false} width="20px" height="20px" className="icon" alt="w.i" src="https://imgur.com/MIGBE08.png" />
          </a>
          <a href="https://www.facebook.com/Sagaon.Tech/">
            <img draggable={false} width="20px" height="20px" className="icon" alt="f.i" src="https://imgur.com/q8MCkx2.png" />
          </a>
          <a href="https://www.youtube.com/channel/UCe3I8UV8iqnB6u71H01SE9w">
            <img draggable={false} width="20px" height="20px" className="icon" alt="y.i" src="https://imgur.com/wVjO3DV.png" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
